<template>
  <v-app>
    <v-navigation-drawer app fixed permanent>
      <grid-settings></grid-settings>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
      class="elevation-1"
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-3"
          contain
          src="../public/img/logo.svg"
          transition="scale-transition"
          width="20"
        />
        UI Grids Playground
      </div>

      <v-spacer></v-spacer>

      <v-btn text to="/" class="mr-2">Playground</v-btn>
      <v-btn text :href="tools_url" class="mr-2" target="_blank">Other Tools</v-btn>
      <v-btn text :href="author_url" target="_blank">Author</v-btn>
    </v-app-bar>

    <v-content>
      <v-container fluid class="px-5 py-5">
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer app height="60">
      <div class="caption">
        UI Grids Playground | Created with 💙 by <a :href="author_url" target="_blank">Masoom S</a>
      </div>
    </v-footer>
  </v-app>
</template>

<style lang="scss">
.grid{
  outline: 1px solid #03a9f4;
  position: relative;
  &__container {
    margin: 2rem auto;
  }
  &__wrap {
    overflow: auto;
  }
  &__col {
    float: left;
  }
}
.clearfix {
  &:before, &:after {
    content: " ";
  }
  &:after {
    display: table;
    clear: both;
  }
}
</style>

<script>
import GridSettings from './components/GridSettings.vue';

export default {
  name: 'App',

  components: {
    GridSettings,
  },

  data: () => ({
    tools_url: 'https://masoomulhaq.com/tools/',
    author_url: 'https://masoomulhaq.com',
  }),
};
</script>
